<template>
  <v-menu
    v-model="opened"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="300px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        prepend-inner-icon="mdi-palette"
        hide-details
        outlined
        readonly
        v-model="formattedDate"
        :label="label"
        :class="inputClass"
        v-on="on"
        v-bind="$attrs"
        @blur="onBlur"
      >
        <template v-slot:append>
          <div :style="swatchStyle" v-on="on">
          </div>
        </template>
      </v-text-field>
    </template>
    <v-card>
      <v-color-picker
        dot-size="25"
        show-swatches
        swatches-max-height="200"
        v-model="localValue"
      ></v-color-picker>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="opened = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>

export default {
  props: ['value', 'label', 'inputClass'],
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
  computed: {
    swatchStyle() {
      return {
        backgroundColor: this.formattedDate,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: this.opened ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out',
      };
    },
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.value = localValue;
        this.$emit('input', localValue);
      },
    },
    formattedDate() {
      return this.localValue;
    },
  },
};
</script>
